import { Guide, useFishingAreas } from "../../Features/FishingGuides";
import React, { useMemo } from "react";

import HtmlRenderer from "../../HtmlRenderer";
import { useLanguage } from "../../hooks/useLanguage";

const labels = {
  seeWebsite: {
    da: "Besøg hjemmeside",
    en: "See website",
    de: "Siehe Website",
  },
  email: {
    da: "Email",
    en: "Email",
    de: "Email",
  },
  phone: {
    da: "Telefon",
    en: "Telephone",
    de: "Telefon",
  },
  openingHours: {
    da: "Åbningstider",
    en: "Opening hours",
    de: "Öffnungszeiten",
  },
  facilities: {
    da: "Faciliteter",
    en: "Facilities",
    de: "Anlagen",
  },
  seeWebpage: {
    da: "Se hjemmeside",
    en: "See website",
    de: "Siehe Website",
  },
  bookAccomodation: {
    da: "Book ophold",
    en: "Book accommodation",
    de: "Unterkunft buchen",
  },
  description: {
    da: "Beskrivelse",
    en: "Description",
    de: "Beschreibung",
  },
};

/*
 * This component displays the content of the guide sidebar
 */

export default function GuidesSidebar(props: { data?: Guide }) {
  const areas = useMemo(() => {
    if (!props.data) return [];
    return props.data.areas.split(",").map(Number);
  }, [props.data]);

  useFishingAreas(areas);
  const language = useLanguage();
  if (!props.data) return null;

  return (
    <div style={{ position: "relative", height: "100%", width: "100%" }}>
      <div id="certifiedHotel">
        <div className="header clearfix">
          <div>
            <h2 className="overskrift">{props.data.name}</h2>
          </div>

          <div>
            <img
              src={props.data.imageUrl}
              alt="Billede af Guide"
              className="hotelImage"
              style={{
                maxHeight: "200px",
                objectFit: "contain",
              }}
            />
          </div>

          <h3>{labels.description[language]}</h3>
          <div style={{ marginBottom: 20 }}>
            <HtmlRenderer html={props.data.description[language]} />
          </div>
          {props.data && props.data.url && (
            <a
              href={`https://${props.data.url}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "white",
              }}
            >
              {labels.seeWebsite[language]}
            </a>
          )}
        </div>
        <div
          className="headlineBar"
          style={{
            marginTop: 20,
          }}
        >
          <span className="label">{labels.email[language]}</span>
          <a href={"mailto:" + props.data.email}>
            <span className="data">{props.data.email}</span>
          </a>
        </div>
        <div className="headlineBar">
          <span className="label">{labels.phone[language]}</span>
          <span className="data">{props.data.phone}</span>
        </div>
      </div>
    </div>
  );
}
